import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  createMeetingRoomModalDialogStyles,
  meetingRoomModalHeaderStyles,
  MEETING_ROOM_MODAL_WIDTH,
} from 'domain/feature/hub/company/meeting-room/shared/meetingRoomModalStyles'

export const StyledModal = styled(Modal)`
  ${createMeetingRoomModalDialogStyles(MEETING_ROOM_MODAL_WIDTH)}
  ${meetingRoomModalHeaderStyles}

  &.modal {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .modal-dialog {
    margin: auto;
  }

  .modal-title {
    font-weight: 500;
  }

  .modal-body {
    padding: 2.5rem 1.5rem 3rem;
  }
`

export const SuccessBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0;
`

export const SuccessIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--green, #22a640);
  margin-bottom: 2rem;
`

export const SuccessCheckIcon = styled(FontAwesomeIcon)`
  font-size: 4.5rem;
  color: var(--white);
`

export const RequestNumberLabel = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-primary);
  margin: 0 0 0.25rem;
`

export const RequestNumberValue = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2rem;
`

export const SuccessDescription = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.5;
`
